import { createSelector } from '@ngrx/store';
import { Status } from '@essent/common';

import { selectFehStandaloneFormsState } from '../feh-standalone-forms.state';
import { generalAdviceFormSelectorKey } from '../reducers';

export const selectGeneralAdviceFormState = createSelector(
  selectFehStandaloneFormsState,
  (state) => state[generalAdviceFormSelectorKey]
);

export const selectGeneralAdviceSubmitState = createSelector(
  selectGeneralAdviceFormState,
  (state) => state.submitState
);

export const selectGeneralAdviceThankYouPage = createSelector(
  selectGeneralAdviceFormState,
  (state) => state.thankYouPageLink
);

export const selectShowThankYouPageFallback = createSelector(
  selectGeneralAdviceSubmitState,
  selectGeneralAdviceThankYouPage,
  (submitState, thankYouPage) =>
    submitState.status === Status.SUCCESS && thankYouPage === null
);
